export default function Column({ children }) {
  return (
    <div className="mr-2 w-3/12 border-r-[1px] border-solid border-slate-300 pr-2">{children}</div>
  );
}
